import { lazyVue } from "@/utils";
export default [
    {
        path: '/login',
        name: 'login',
        title: '登录',
        component: lazyVue('auth/login'),
        meta: {
            title: '登录',
            name: '登录'
        }
    },
    {
        path: '/terms_of_service',
        name: 'terms_of_service',
        title: '服务条款',
        component: lazyVue('auth/terms_of_service'),
        meta: {
            title: '服务条款',
            name: '服务条款'
        }
    },
    {
        path: '/weixinLoginValidate',
        name: 'weixinLoginValidate',
        title: '微信授权',
        component: lazyVue('auth/weixinLoginValidate'),
        meta: {
            title: '微信授权',
            name: '微信授权'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/auth/index.js